// extracted by mini-css-extract-plugin
export default {"component":"system-message_component__LdBn-","compact":"system-message_compact__uxng8"};